import businessClient from 'src/services/clients/business'
import { IMeta, IItemType } from 'src/common/interfaces/index.js'

const ISettingsItemTypeListResponse = { meta: IMeta, data: { list: [IItemType] } }

export const settingsItemType = {
  /**
   * @param {store_id: number} filter
   * @return {Promise<ISettingsItemTypeListResponse>}
   */
  list(filter, signal) {
    return businessClient().post('item-type/portal/list', { filter }, { signal })
  },

  /**
   * @param {{id: number, name: string}} data
   * @return {Promise<ISettingsItemTypeListResponse>}
   */
  upsert(data, signal) {
    return businessClient().post('item-type/upsert', { data }, { signal })
  },

  /**
   * @param {{id: number }} filter
   * @return {Promise<ISettingsItemTypeListResponse>}
   */
  archive(filter, signal) {
    return businessClient().post('item-type/archive', { filter }, { signal })
  },
}
